<template>
  <div>
    <EbHeading level="h1" class="eb-page-heading eb-upper-title">Se connecter</EbHeading>
    <EbBanner :timestamp="bannerTimestamp" :isActive="showError" id="error" type="error" title="Erreur" @removeBanner="showError=false"><b>L'identifiant ou le mot de passe est incorrect.</b> <p>Problème de connexion ? <a href="mailto:numerique@maine-et-loire.fr" title="Contacter le Département de Maine-et-Loire - fenêtre de messagerie">Contactez le Département de Maine-et-Loire</a> (numerique@maine-et-loire.fr)</p></EbBanner>
    
    <EbBanner :timestamp="bannerTimestamp" :isActive="successActivation" type="success" title="Activation réussie de votre compte" @removeBanner="successActivation=false">Votre compte a bien été activé, vous pouvez désormais vous connecter. </EbBanner>
    <EbBanner :isActive="errorActivation" type="error" title="Activation de votre compte échouée" @removeBanner="errorActivation=false">Le lien d’activation a expiré. Veuillez ressaisir vos identifiants fournis par courrier postal.</EbBanner>
    <EbBanner :timestamp="bannerTimestamp" :isActive="errorActivationServer" type="error" title="Activation de votre compte échouée" @removeBanner="errorActivationServer=false">Une erreur est survenue, veuillez <a href="mailto:numerique@maine-et-loire.fr" title="Contacter le Département de Maine-et-Loire - fenêtre de messagerie">contacter le Département de Maine-et-Loire</a> (numerique@maine-et-loire.fr)</EbBanner>
    
    <form action="#" @submit.prevent="submit">
      <EbInput label="Identifiant" width="expand" v-model="username" helpText="Courriel ou nom d’utilisateur/utilisatrice" required />
      <EbPassword label="Mot de passe" width="expand" required v-model="password" />
      <router-link :to="{ name: 'forgotPassword', params: {login: username} }">Mot de passe oublié&nbsp;?</router-link>      
      <EbButton type="submit" centered="centered" expanded="expanded" site-color="site-color">Je me connecte</EbButton>
    </form>
    <a href="https://assmat.maine-et-loire.fr" target="_blank" rel="noreferrer noopener" title="Consulter le site assmat.maine-et-loire.fr - Nouvelle fenêtre">Consulter le site assmat.maine-et-loire.fr <font-awesome-icon :icon="['fas', 'external-link-alt']"/></a>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Login',
  props: {
    token: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      username: '',
      password: '',
      showError: false,
      successActivation: false,
      errorActivation: false,
      errorActivationServer: false,
      bannerTimestamp: ''
    }
  },
  mounted() {
    if (this.$store.getters.isAuthenticated) {
      this.$router.push({ name: 'home' })
    }
    else if(this.token) {
      this.setProfil()
    }
  },
  methods: {
    ...mapActions(['LogIn']),
    submit: async function() {
      const user = {
        username: this.username,
        password: this.password
      }
      try {
        await this.LogIn(user)
        
        this.showError = false
        
        this.$router.push({ name: 'home' })
      } catch (error) {
        let errorCode = error.response.status
        if(errorCode == 403) this.$router.push({ name: 'firstConnection', params: {username: this.username, codeActivation: this.password} })
        else if(errorCode == 401) {
          this.showError = true
          this.bannerTimestamp = this.getTime()
        }
        
      }
    },
    setProfil: async function() {
      await this.$http.put('authentification/activationCompte/active?isComptePartenaire=true', {
        token: this.token
      })
      .then(resp => {
        this.successActivation = true
        this.errorActivation = false
        this.bannerTimestamp = this.getTime()
      })
      .catch(error => {
        this.successActivation = false
        this.errorActivation = false
        this.errorActivationServer = false
        this.bannerTimestamp = this.getTime()
        
        if(error.response.data.codeErreur == 'TOKEN_NOT_EXISTS') this.errorActivation = true
        else this.errorActivationServer = true
        this.bannerTimestamp = this.getTime()
      })
    },
  }
}
</script>
